<div class="gate-container">
    <div class="gate-title">
        <h1>
            <span>{{ 'Gate.Title' | translate }}</span>
            <span class="dmi-status-indicator">
                <sl-dmi-status-indicator #dmiStatusIndicator />
            </span>
        </h1>
    </div>
    <div class="gate-buttons-container">
        <mat-button-toggle-group name="action-type" [(ngModel)]="actionType">
            <mat-button-toggle [value]="GateActionTypeEnum.Checkin" class="button-toggle-checkin">
                {{ 'Gate.Checkin' | translate }}
            </mat-button-toggle>
            <mat-button-toggle [value]="GateActionTypeEnum.CheckinRepresentative" class="button-toggle-representative">
                {{ 'Gate.CheckinRepresentative' | translate }}
            </mat-button-toggle>
            <mat-button-toggle [value]="GateActionTypeEnum.Checkout" class="button-toggle-checkout">
                {{ 'Gate.Checkout' | translate }}
            </mat-button-toggle>
        </mat-button-toggle-group>
    </div>
    <div class="gate-input-container">
        <form (submit)="submit()">
            <mat-form-field
                appearance="outline"
                floatLabel="always"
                subscriptSizing="dynamic"
                [color]="actionType === GateActionTypeEnum.Checkout ? 'warn' : undefined">
                <mat-label>{{ 'Gate.Barcode' | translate }}</mat-label>
                <input #barcodeInput matInput name="barcode" [(ngModel)]="barcode" autocomplete="off" />
                @if (!barcode && hasMediaDevices) {
                    <button type="button" mat-icon-button matSuffix (click)="openBarcodeScanDialog()">
                        <mat-icon>qr_code_scanner</mat-icon>
                    </button>
                }
                <!-- manual clear button -->
                @if (!!barcode) {
                    <button type="button" mat-icon-button matSuffix (click)="barcode = ''">
                        <mat-icon>close</mat-icon>
                    </button>
                }
            </mat-form-field>
        </form>
    </div>
    <mat-divider />
    <div class="log-title">Log</div>
    <div class="gate-log-container" #logContainer>
        @for (logItem of log(); track logItem.timeStamp) {
            <div
                [ngClass]="{ 'log-item-error': !logItem.success, 'log-item-checkout': logItem.actionType === GateActionTypeEnum.Checkout }">
                <span>{{ logItem.timeStamp | date: 'HH:mm:ss' }} -&nbsp;</span>
                <span>{{ 'Gate.' + logItem.actionType | translate }}&nbsp;</span>
                <span>({{ logItem.shareholderIdOrBarcode ?? '' }})&nbsp;</span>
                <span>{{ (logItem.success ? 'Alert.Success' : 'Alert.Error') | translate }}</span>

                @if (!logItem.success && logItem.message) {
                    <span>: {{ logItem.message }}</span>
                }
            </div>
        }
    </div>
</div>
